import {
  identity,
  curry,
  mapValues,
  propOr,
  cond,
  isFunction,
  isObject,
  T,
  always,
} from 'lodash/fp';

const when = predicate => trueFn => props =>
  predicate(props) ? trueFn(props) : identity(props);

const evolve = curry((transformations, item) =>
  // @ts-expect-error discontinued package ?
  mapValues.convert({ cap: false })((value, key) => {
    const transformation = propOr(identity, key, transformations);

    return cond([
      [isFunction, t => t(value)],
      [isObject, t => evolve(t, value)],
      [T, always(value)],
    ])(transformation);
  }, item)
);

export { when, evolve };
